import styled from 'styled-components';
import withTheme from '../../Theme';

export const Pedal = withTheme((styled.div`
  border-radius: 4px;
  background-position: center;
  background-repeat: ${({custom}: any) => custom ? 'repeat' : 'no-repeat'};
  background-size: ${({custom}: any) => !custom && 'contain'};

  display: flex;
  align-items: center;

  transform: ${(props: any) => {
    const { position, rotate } = props;
    return position ? `${position} rotate(${rotate}deg) !important` : rotate && `rotate(${rotate}deg) !important`;
  }};

  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  .custom-msg {
    opacity: 0.3;
    width: 100%;
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 1.2em;
  }

  .actions { 
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &.active {
    z-index: 100;
  }
`));

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(20, 20, 20, 0.55);
  z-index: 50;
  width: 100%;
  height: 100%;
`;